module.exports = __webpack_public_path__ + "img/81.9f90219f.jpg";